
<template>
    <div>
        <div class="banner">
            <img class="banner-img" src="https://cdn.zxzx119.com/zxzx-h5/activity/accompanyBag/banner.png" alt="" srcset="">
        </div>
        <div class="content">
            <img class="content-title" :src="'https://cdn.zxzx119.com/zxzx-h5/activity/accompanyBag/icon1.png?date='+date" alt="" srcset="">
            <img class="content-img" :src="'https://cdn.zxzx119.com/zxzx-h5/activity/accompanyBag/img1.png?date='+date" alt="" srcset="">
            <img class="content-btn" @click='postMsg(14015)' style="margin-bottom: 25px;margin-top: 5px;" 
            :src="'https://cdn.zxzx119.com/zxzx-h5/activity/accompanyBag/btn1.png?date='+date" alt="" srcset="">
            <img class="content-img" :src="'https://cdn.zxzx119.com/zxzx-h5/activity/accompanyBag/img2.png?date='+date" alt="" srcset="">
            <img class="content-btn" @click='postMsg(14015)' style="margin-bottom: 42px;margin-top: 5px;" 
            :src="'https://cdn.zxzx119.com/zxzx-h5/activity/accompanyBag/btn1.png?date='+date" alt="" srcset="">
        </div>
         <div class="content content2">
            <img class="content-title" :src="'https://cdn.zxzx119.com/zxzx-h5/activity/accompanyBag/icon2.png?date='+date" alt="" srcset="">
            <img class="content-img" :src="'https://cdn.zxzx119.com/zxzx-h5/activity/accompanyBag/img3.png?date='+date" alt="" srcset="">
            <img class="content-img" style="margin-bottom: 40px;" :src="'https://cdn.zxzx119.com/zxzx-h5/activity/accompanyBag/img4.png?date='+date" alt="" srcset="">
         </div>
    </div>
</template>
<script>
import wxShare from '../../../wx/weixin.js'
export default {
    name:'',
    components: {
    },
    data () {
        return {
            isApp: 0, // 0: h5  1/2 : app  3: 小程序
             date :"",
        }
    },
    created () {
        this.isApp = parseInt(this.$route.query.isApp) ? parseInt(this.$route.query.isApp) : 0;
         this.init()
    },
    methods: {
        postMsg(num) {
            console.log("isApp:", this.isApp)
            if (this.isApp == 3) {
                uni.navigateTo({//redirectTo
                    url : "/pages/goods-detail/goods-detail?goodId="+num,
                })
            } else if (this.isApp == 0) {//h5
                this.$router.push({
                    path: '/goodsdetail',
                    query: {
                        goodsId: num,
                        businessId: 26359
                    }
                    })
            } else if (this.isApp == 1||this.isApp == 2) {
                if (this.utils.isIphone()) { // ios 
                    window.webkit.messageHandlers.toShopInfoPage.postMessage({supplierId : '26359','goodsId': num+''})
                } else {
                    window.zxzx.toShopInfoPage(26359,num)
                }
            }
        },  
        init() {
             var userAgent = navigator.userAgent;
            let imgUrl = 'https://cdn.zxzx119.com/zxzx-h5/activity/accompanyBag/share.png'
            wxShare.wxRegister('沁夏随行包', '', imgUrl)
        }
    },
    mounted () {
        this.date = new Date().getTime()
        console.log(this.date)
        this.$nextTick(() => {
            document.addEventListener("UniAppJSBridgeReady", function () {
                uni.getEnv(function(res) {
                    // console.log('当前环境：' + JSON.stringify(res));
                });
            })
        })
    },
}

</script>


<style lang='scss' scoped>
.banner{
    width: 100%;
    background: #fff;
    .banner-img{
        width: 100%;
        height: 100%;
    }

}
.content{
    text-align: center;
    background-color: #fff;
     padding: 0 5px;
    .content-title{
        width: 140px;
        margin-top: 14px;
        margin-bottom: 20px;
    }
    .content-img{
        width: 100%;
       

    }
    .content-btn{
        width: 125px;
    }
}
.content2{
    background-color: #F6F6F6;
    padding: 0 15px;
    .content-title{
        width: 115px;
        margin-top: 40px;
        margin-bottom: 25px;

    }
    .content-img{
        width: 100%;
        margin-bottom: 25px;
    }
}
</style>


// WEBPACK FOOTER //
// src/view/activity/accompanyBag/index-h5.vue